export default __webpack_public_path__ + "static/typography-image-f-9ab809426fea1c27f388e6f6b226c09f.png";